<template>
    <div>
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container" v-bind:style="ContainerPadding">
                    <div class="">
                        <!-- Accordion -->
                        <div class="accordion accordion-flush shadow-lg">

                            <template v-for="(tag, idx) in MasterTagList">

                                <div v-if="BlockProps.Tags.length == 0 || BlockProps.Tags.indexOf(tag) >= 0" class="accordion-item">
                                    <div class="accordion-header">
                                        <a @click="ShowCat(tag)" class="accordion-button" role="button" data-bs-toggle="collapse">
                                            {{tag}}
                                        </a>
                                    </div>
                                    <div style="background-color: white !important;" :id="'flush-collapse' + tag.replace(' ', '')" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <ul class="list-unstyled m-0">
                                                <li class="p-1" v-for="faq in FAQsByTag[tag]"><a @click="ShowFAQ(faq)" href="javascript:void(0)">{{faq.question}}</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </template>

                        </div>
                        <!-- End Accordion -->
                    </div>
                </div>




            </div>
        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-labelledby="" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="">Configure FAQ</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>

                        <div class="h5">Categories To Show (leave empty to show all)</div>
                        <div v-for="(item, index) in MasterTagList" :key="index">
                            <input type="checkbox" v-model="BlockProps.Tags" :value="item">
                            {{ item }}
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button @click="GetFAQs" type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>

        <div id="FAQDetail" style="z-index:300" class="modal" tabindex="-1" aria-labelledby="" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="">Frequently Asked...</h5>
                    </div>
                    <div class="modal-body shadow-sm" style="padding-top:5px;">
                        <hr style="margin-top: 10px; margin-bottom:5px;" />
                        <div class="h4" style="color:blue;padding-top:5px;"><i class="bi-question-circle"></i> {{FAQDetail.question}}</div>

                        <hr style="margin-top: 5px; margin-bottom:15px;" />
                        <div v-html="FAQDetail.answer"></div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'
    import axios from '/src/components/NovaAxios.js';
    import { toast } from 'vue3-toastify';


    export default {
        inheritAttrs: false,
        name: 'FAQ2',
        mixins: [ContentBlockBase],
        props: ['faqtags'],
        components: {
        },
        computed:
        {
            MasterTagList: function () {
                var x = this.Store.MasterFaqTags;
                if (this.faqtags) {
                    return this.faqtags
                }

                if (this.Store && this.Store.MasterFaqTags)
                {
                    return this.Store.MasterFaqTags;
                }
            }
        },
        data() {
            return {  
                FAQsByTag: {},
                FAQDetail: {}
            };
        },
        watch: {
           
        },
        methods:
        {
            ShowCat: function (tag) {
                var id = `flush-collapse${tag.replace(' ', '')}`;
                var ele = document.getElementById(id);
                if (ele) {
                    var instance = bootstrap.Collapse.getOrCreateInstance(ele);
                    var show = () => {
                        nextTick().then(() => {
                            instance.show()                            
                        });
                    }

                    if (instance._isShown()) {
                        instance.hide();
                        return;
                    }

                    if (this.FAQsByTag[tag]) {
                        show();
                    }
                    else {
                        this.GetFAQs(tag, show);
                    }
                }
            },
            ShowFAQ: function (faq) {
                this.FAQDetail = faq;
                
                var id = '#FAQDetail';
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
            GetFAQCats: function () {
                var that = this;
                var token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
                
                axios.postForm('/API/GetFAQCats', {
                    
                }, {
                    cache: false,
                    headers: {
                        'RequestVerificationToken': token
                    }
                }).then(function (response) {
                    if (response.data.success) {
                        that.Store.MasterFaqTags = response.data.cats || [];
                        if (that.iseditmode && (!response.data.cats || !response.data.cats.length)) {
                            toast.warning("Be sure to add Frequently Asked Questions and answers (currently shown on this page) via the admin site at <a href='https://admin.notarylaunchpad.com/home/faq'>https://admin.notarylaunchpad.com</a>, or consider removing the FAQ page block."
                                , { 'position': 'top-center' });
                        }
                    }
                    else {
                        toast.error("Failed loading FAQ categories! " + response.data.msg);
                    }

                }).catch(function (error) {
                    toast.error("There was an error. Please refresh the page and try again.");
                });
            },
            GetFAQs: function (tag, cb) {
                if (!tag || !tag.length) {
                    return;
                }

                var that = this;
                var token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;

                axios.postForm('/API/GetFAQs', {
                    tagFilter: [tag],
                }, {
                    cache: false,
                    headers: {
                        'RequestVerificationToken': token
                    }
                }).then(function (response) {
                    if (response.data.success) {
                        const faqs = response.data.faqs || [];
                        that.FAQsByTag[tag] = faqs.sort((a, b) => {
                            const aOrder = a.sortOrder ?? 0;
                            const bOrder = b.sortOrder ?? 0;
                            if (aOrder === bOrder) {
                                return 0;
                            }
                            return bOrder - aOrder;
                        });
                        if (cb) { cb(); }                        
                    }
                    else {
                        toast.error("Failed loading FAQs! " + response.data.msg);
                    }

                }).catch(function (error) {
                    toast.error("There was an error. Please refresh the page and try again.");
                });
            },
         
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
        
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
           
        },
        beforeUnmount()
        {
           
        },
        mounted() {
            this.GetFAQCats();
            nextTick().then(() => {
      
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
</style>

